import React, { useCallback, useMemo, useRef } from 'react';

import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import './OrderOptions.scss'

export type OrderOption = {
    name: string, productID: number, width: number, price: number, totalLength?:number, height?:number
}

interface IOrderOptions {
    placeholder: string
    value: string
    list: OrderOption[]
    onValueSelected: (order: OrderOption, index: number) => void,
    onSelectionCancelled: () => void
}

export const OrderOptions = (props: IOrderOptions) => {

    const listRef = useRef(undefined as any)

    const list = useMemo(() => {
        return props.list.map((option: any) => ({
            text: option.name,
            value: option.productID,
        }))
    }, [props.list])

    const selectCategory = useCallback(() => {
        if (listRef.current) {
            const value = listRef.current.value
            if (value) {
                const index = props.list.findIndex((option: any) => option.name === value)
                if (index+1) {
                    props.onValueSelected(props.list[index], index);
                }
            } else if (value === null) {
                props.onSelectionCancelled();
            }

        }
    }, [props.list, props.onValueSelected])

    return <DropDownListComponent placeholder={props.placeholder} value={props.value} ref={listRef} onChange={selectCategory} dataSource={list} />
}